import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vfs-sal-cond-img-imp-steps',
  templateUrl: './sal-cond-img-imp-steps.component.html',
  styleUrls: ['./sal-cond-img-imp-steps.component.scss']
})
export class SalCondImgImpStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
